export enum Status {
  Idle,
  Loading,
  Success,
  Failure,
}
